import { render, staticRenderFns } from "./BackendApp.vue?vue&type=template&id=993d07b4&scoped=true&"
import script from "./BackendApp.vue?vue&type=script&lang=js&"
export * from "./BackendApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "993d07b4",
  null
  
)

export default component.exports